import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiUsuarioService } from '../services/api-usuario.service';
import { AppService } from '../services/app.service';
import { PlatformService } from '../services/platform.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard  {

    constructor(private apiUsuario: ApiUsuarioService, private router: Router, private appService: AppService){}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.verificarAcesso(state.url);
    }

    private verificarAcesso(redirectUrl: string) {
        const credenciais = this.apiUsuario.getCredenciais();
        if (credenciais) {
            if (this.exigeAlteracaoSenha(credenciais) && !this.rotaPermitidaComSenhaPendente(redirectUrl)) {
                return this.router.createUrlTree(['/perfil-usuario'], { queryParams: { alterarSenha: 'true' } });
            }
            return true;
        }

        if (PlatformService.isInIframe()) {
            this.apiUsuario.sendSessionExpired();
            return this.router.createUrlTree(['/loading']);
        }

        this.router.navigate(['/login'], { queryParams: { returnUrl: redirectUrl } });
        return false;
    }

    private exigeAlteracaoSenha(credenciais: any): boolean {
      if (this.appService.isEmbeddedMode()) return false;
      if (credenciais.senhaRequerAlteracao) return true;
      if (typeof credenciais.diasParaExpirarSenha === 'number'
          && credenciais.diasParaExpirarSenha <= 0) {
          return true;
      }
      return false;
    }

    private rotaPermitidaComSenhaPendente(url: string): boolean {
        const path = (url || '').split('?')[0];
        return path === '/perfil-usuario';
    }
}
